// extracted by mini-css-extract-plugin
export default {"boxInfo":"DomainDetailHeader_boxInfo__2F3Qd","connectionContainer":"DomainDetailHeader_connectionContainer__2PlAn"};